import { UseBaseQueryOptions, useQuery } from '@tanstack/react-query'
import { getOperatorById } from '../../services'
import { AdminQueryKey } from '@/modules/admin/keys'
import { OperatorDataResponse } from '@/modules/manage-operator/types'

export default function useQueryGetOperatorById(
	operatorId: string,
	props?: UseBaseQueryOptions<OperatorDataResponse>,
) {
	return useQuery({
		queryKey: [AdminQueryKey.GetOperatorById, operatorId],
		queryFn: () => getOperatorById(operatorId),
		...props,
	})
}
